import React from "react";
import { Box } from "@mui/material";
import { useSystems } from "../../../../context/SystemContext";
import ConnectionRequests from "./widgets/ConnectionRequests";
import FeaturedJobs from "./widgets/FeaturedJobs";
import RecommendedCourses from "./widgets/RecommendedCourses";
import CorporateServices from "./widgets/CorporateServices";
import ProfessionalServices from "./widgets/ProfessionalServices";


export const SidebarRightWidgets = () => {
  const { activeProfile } = useSystems();
  const profileType = activeProfile?.type;
  const showVacantes = profileType === 'professional';
  const showCursosDerecha = profileType === 'enterprise';

  return (
    <Box>
      <ConnectionRequests />
      {showVacantes && <FeaturedJobs />}
      {showCursosDerecha && <RecommendedCourses />}
      <CorporateServices />
      <ProfessionalServices />
    </Box>
  );
};
